import React from 'react';
import '../index.css';

export default function Footer() {
   return (
      <div className='footer'>
         <p><small>© 2022 Melson Development. All rights reserved.</small></p>
      </div>
   )
}